"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Delete = void 0;
var tslib_1 = require("tslib");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var Delete_1 = require("@reactionable/core/lib/crud/delete/Delete");
var react_1 = tslib_1.__importDefault(require("react"));
var Button_1 = tslib_1.__importDefault(require("react-bootstrap/Button"));
function Delete(_a) {
    var label = _a.label, _b = _a.icon, icon = _b === void 0 ? { icon: free_solid_svg_icons_1.faTrashAlt } : _b, props = tslib_1.__rest(_a, ["label", "icon"]);
    return (react_1.default.createElement(Delete_1.Delete, tslib_1.__assign({}, props),
        react_1.default.createElement(Button_1.default, { variant: "danger", title: props.title || '' },
            icon && react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, tslib_1.__assign({ className: label ? 'mr-2' : '' }, icon)),
            label)));
}
exports.Delete = Delete;
//# sourceMappingURL=Delete.js.map